import { CardHeader } from '@/modules/simulation/components/ListPanel/CardHeader';
import { CardContent } from './CardContent';
import { Box } from '@mui/material';
import { SimulationGroup } from '@thive/fddm-types';
import { useCallback, useEffect, useState } from 'react';

type Props = {
  simulationGroup: SimulationGroup;
  isSelected: boolean;
  onSelect: (simulationGroup: SimulationGroup, isSelected: boolean) => void;
  onDetails: (simulationGroup: SimulationGroup) => void;
  onEdit: (simulationGroup: SimulationGroup) => void;
  onRerun: (simulationGroup: SimulationGroup) => void;
  onAbort: (simulationGroup: SimulationGroup) => void;
  onDelete: (simulationGroup: SimulationGroup) => void;
};

const containerSx = {
  border: '2px solid transparent',
  borderBottom: '1px solid transparent',
  borderBottomColor: 'neutral.lighter',
  padding: '12px 0',
};

export function ListPanelCard({
  simulationGroup,
  isSelected: selected,
  onSelect,
  onDetails,
  onEdit,
  onRerun,
  onAbort,
  onDelete,
}: Props) {
  const [isHover, setIsHover] = useState(false);
  const [isSelected, setIsSelected] = useState(selected);

  // Sync internal state when parent changes the prop
  useEffect(() => {
    // PLZ FIX ME
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsSelected(selected);
  }, [selected]);

  const handleSelect = useCallback(() => {
    const next = !isSelected;
    setIsSelected(next);
    onSelect(simulationGroup, next);
  }, [isSelected, onSelect, simulationGroup]);

  const isSelectedSx = isSelected
    ? {
        borderWidth: '2px',
        borderColor: 'primary.main',
        paddingBottom: '12px',
      }
    : {};

  return (
    <Box
      sx={{ ...containerSx, ...isSelectedSx }}
      onMouseEnter={() => setIsHover(true)}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      component='article'
      className={isSelected ? 'selectedBox' : 'simulationBox'}
    >
      <CardHeader
        simulationGroup={simulationGroup}
        isHover={isHover}
        onClick={handleSelect}
        onDetails={onDetails}
        onEdit={onEdit}
        onRerun={onRerun}
        onDelete={onDelete}
      />
      <CardContent
        simulationGroup={simulationGroup}
        isHover={isHover}
        onClick={handleSelect}
        onAbort={onAbort}
      />
    </Box>
  );
}
